/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TipSettings model module.
* @module model/TipSettings
* @version 1.0.0
*/
export default class TipSettings {
    /**
    * Constructs a new <code>TipSettings</code>.
    * @alias module:model/TipSettings
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>TipSettings</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TipSettings} obj Optional instance to populate.
    * @return {module:model/TipSettings} The populated <code>TipSettings</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TipSettings();
                        
            
            if (data.hasOwnProperty('AllowCustomAmounts')) {
                obj['AllowCustomAmounts'] = ApiClient.convertToType(data['AllowCustomAmounts'], 'Boolean');
            }
            if (data.hasOwnProperty('CustomPercentages')) {
                obj['CustomPercentages'] = ApiClient.convertToType(data['CustomPercentages'], ['Number']);
            }
            if (data.hasOwnProperty('MaximumPercentage')) {
                obj['MaximumPercentage'] = ApiClient.convertToType(data['MaximumPercentage'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Boolean} AllowCustomAmounts
    */
    'AllowCustomAmounts' = undefined;
    /**
    * @member {Array.<Number>} CustomPercentages
    */
    'CustomPercentages' = undefined;
    /**
    * @member {Number} MaximumPercentage
    */
    'MaximumPercentage' = undefined;




}
